import { useState, useEffect } from 'react'
import { Progress } from '@components/ui/progress'

const ImageGenerationProgress = ({ startedAt }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const startDate = new Date(startedAt)
    
    const interval = setInterval(() => {
      const elapsed = startedAt ? Date.now() - startDate.getTime() : 0
      const progress = Math.min(elapsed / 62_000, 0.97)
      setProgress(progress)
    }, 100)

    return () => clearInterval(interval)
  }, [startedAt])

  return (
    <Progress value={progress * 100} />
  )
}

export default ImageGenerationProgress
